import { Entity } from '../Entity';
import { Facet } from '../facets/Facet';

type ExtractProps<T> = T extends Entity<infer P>
  ? P
  : T extends Facet<infer P> ? P : never;

export const create = <E extends Entity<any> | Facet<any>>(
  Constructor: { new (props: ExtractProps<E>): E },
  props: ExtractProps<E>,
): E => {
  return new Constructor(props);
};
